import { useContext, useRef, useState } from 'react'
import { usePageInfo } from 'app/frontend/base/config/queries'
import { useTeamMenuItems } from '../../TeamDashboard/components/TeamSubheader'
import GuildContext from 'app/frontend/base/config/context/guild'
import EntityMenu from 'app/frontend/base/components/EntityMenu'
import BannerImage from 'app/frontend/base/components/BannerImage'
import { Link } from 'react-router-dom'
import { useTheme } from '@/components/theme-provider'
import AppContext from 'app/frontend/base/config/context/app'
import { LOGIN_BUTTONS_COMPONENT_WIDTH } from 'app/frontend/base/components/LoginButtons'
import { useCustomDomain } from 'app/frontend/base/hooks/useCustomDomain'

const CustomDomainHeader = () => {
  const { currentScheme } = useTheme()
  const { currentCharacterRef } = useContext(AppContext)
  const [logoWidth, setLogoWidth] = useState<number | null>(null)
  const logoRef = useRef<HTMLImageElement>(null)
  const { customDomain } = useCustomDomain()
  const {
    data: { user },
  } = usePageInfo()

  if (!customDomain) return null

  const nameLength = (currentCharacterRef?.name || user?.battletag)?.length
  const profileWidth =
    90 + (nameLength ? nameLength * 9 : LOGIN_BUTTONS_COMPONENT_WIDTH)

  const headerLogoPath =
    currentScheme === 'dark'
      ? customDomain?.darkModeHeaderLogoPath
      : customDomain?.lightModeHeaderLogoPath

  return (
    <div className='flex items-center gap-4'>
      <Link to='/' className='flex items-center gap-2 shrink-0'>
        {headerLogoPath ? (
          <img
            ref={logoRef}
            src={headerLogoPath}
            className='h-10 min-h-10 w-auto'
            onLoad={() => setLogoWidth(logoRef.current?.offsetWidth ?? null)}
          />
        ) : (
          <BannerImage
            className='w-12 h-12 min-w-12 min-h-12'
            faction={customDomain.guild.faction}
            fileName={customDomain.guild.bannerFilename}
            size='custom'
          />
        )}

        {customDomain.headerShowName ? (
          <span className='text-xl font-bold text-accent-foreground max-sm:hidden'>
            {customDomain.guild.name}
          </span>
        ) : null}
      </Link>

      <div className='flex items-center gap-0'>
        {customDomain.team ? (
          <GuildContext.Provider
            value={{
              guild: customDomain.guild,
              guildReference: customDomain.guild,
              currentTeam: customDomain.team,
              teamReference: customDomain.team,
            }}
          >
            <CustomDomainTeamHeader
              usedWidth={
                profileWidth +
                (logoWidth || 50) +
                20 +
                (customDomain.headerShowName
                  ? customDomain.guild.name.length * 14
                  : 0)
              }
            />
          </GuildContext.Provider>
        ) : (
          <GuildContext.Provider
            value={{
              guild: customDomain.guild,
              guildReference: customDomain.guild,
            }}
          >
            <CustomDomainGuildHeader />
          </GuildContext.Provider>
        )}
      </div>
    </div>
  )
}

const CustomDomainTeamHeader = ({ usedWidth }: { usedWidth: number }) => {
  const { menuItems } = useTeamMenuItems()
  if (!menuItems.length) return null

  return (
    <EntityMenu
      menuItems={menuItems}
      placement='header'
      usedWidth={usedWidth}
    />
  )
}

const CustomDomainGuildHeader = () => {
  return <div>CustomDomainGuildHeader</div>
}

export default CustomDomainHeader
